import { useServices } from '@core/utils/ioc'

const useProductEvents = () => {
  const { api } = useServices()

  const postVariantViewedEvent = (searchTerm: string) => {
    api.events.postVariantViewedEvent(searchTerm)
  }

  return {
    postVariantViewedEvent,
  }
}

export default useProductEvents
